import { Trans } from 'react-i18next'
import { StyleSheet, View, ViewProps } from 'react-native'
import { Color, Radius, Spacing, Text } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    backgroundColor: Color.simplyWhite,
    padding: Spacing.S,
    borderRadius: Radius.M,
    borderColor: Color.calmGrey,
    borderWidth: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  title: {
    color: Color.calmGrey,
  },
  content: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: Spacing.L,
  },
  bars: {
    flexDirection: 'row',
    borderRadius: Radius.XS,
    overflow: 'hidden',
  },
  bar: {
    height: 14,
    width: 30,
    marginRight: Spacing.XS,
  },
  free: {
    backgroundColor: Color.green,
  },
  occupied: {
    backgroundColor: Color.red,
  },
  labelText: {
    lineHeight: 14,
    marginRight: Spacing.S,
  },
  noSensor: {
    backgroundColor: Color.calmGrey,
  },
})

interface Props extends ViewProps {}

const LegendState = (props: Props) => {
  const { style, ...otherProps } = props

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <Text style={styles.title} numberOfLines={1}>
        <Trans>Workspace status</Trans>
      </Text>
      <View style={styles.content}>
        <View style={[styles.bar, styles.free]} />
        <Text style={styles.labelText} numberOfLines={1} level={7}>
          <Trans>Online and connected</Trans>
        </Text>
        <View style={[styles.bar, styles.occupied]} />
        <Text style={styles.labelText} numberOfLines={1} level={7}>
          <Trans>Offline or disconnected</Trans>
        </Text>
        <View style={[styles.bars, styles.bar, styles.bar, styles.noSensor]} />
        <Text numberOfLines={1} level={7}>
          <Trans>Unknown</Trans>
        </Text>
      </View>
    </View>
  )
}

export default LegendState
